//@import dependencies
import React, {useState, useEffect} from 'react'
import parse from 'html-react-parser';
//@end

//@import components
import PublicAppContainer from 'app_components/layouts/public'
import TextComponent from 'app_components/commons/TextComponent/TextComponent'
//@end

// @INFO Import types
import { ILanding } from 'app_types/admin/landings/landingTypes';
// @end

// @INFO Import services
import LandingService from 'app_services/admin/landings/landingService';
// @end

// @INFO Import Styles
import './../businessScreen.scss'
import TestimoniesModulesLanding from 'app_components/modules/TestimoniesModulesLanding/TestimoniesModulesLanding';
import LandingFilter from 'app_components/modules/LandingFilter/LandingFilter';
import CorporateTraining from './corporate-training/CorporateTraining';

// @ADD Component types
interface IBusinessScreenLayoutProps {}

const BusinessScreenLayout: React.FC<IBusinessScreenLayoutProps> = (props) => {

  const [landing, updateLanding] = useState<ILanding | undefined>(undefined)

  // @INFO Servicios
  const landingService = new LandingService()

  useEffect(() => {
    getLandingData()
  },[])

  /**
   * @INFO Obtener la data para la landing
   */
  const getLandingData = async () => {
    let httpParams: any = {
      slug: 'business'
    }
    const landingResponse = await landingService.fetchLandingData(httpParams)
    if (landingResponse) {
      updateLanding(landingResponse)
    }
  }

  return(
    <PublicAppContainer>
      <div className='business-screen-layout'>
        <div className="container-header-page">
          <div className="business-screen--image-container">
            {landing?.landing?.descriptive_training?.image && (
              <img
                src={landing?.landing?.descriptive_training?.image ? landing?.landing?.descriptive_training?.image : ''}
                alt=""
              />
           )}
          </div>
          <div className="business-screen--text-big-container">
            <div className="business-screen--text-container">
                {landing?.landing?.descriptive_training && (
                <>
                {landing?.landing?.descriptive_training?.title && (
                  <TextComponent className='business-screen--title-text'> {landing?.landing?.descriptive_training?.title}</TextComponent>
                )}
                <div>
                  {landing?.landing?.descriptive_training?.content && (
                    <div className='business-screen--text'>{parse(landing?.landing?.descriptive_training?.content ? landing?.landing?.descriptive_training?.content : '')}</div>
                  )}
                </div>
                </>
                )}
            </div>
          </div>
        </div>
        <section>
          <CorporateTraining/>
        </section>
        <section>
          <LandingFilter />
        </section>
        <section style={{ marginBottom: '30px' }}>
          <TestimoniesModulesLanding slug='business' />
        </section>
      </div>
    </PublicAppContainer>
  )
}

export default BusinessScreenLayout
